const initialState = {
    companiesData: []
};

const companiesReducer = (state = initialState, action) => {
    if (action.type === 'COMPANY_DATA') {
		return Object.assign({}, state, {
            companiesData: action.companiesData
		});
    }
    return state;
};

export default companiesReducer;


// WEBPACK FOOTER //
// ./src/reducers/companiesReducer.js